import React, { useState, useEffect } from 'react';
import './App.css';
import { TypeAnimation } from 'react-type-animation';
import { FaSun, FaMoon, FaMapMarkerAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import ScrollToTopButton from './components/ScrollToTopButton';
import Contact from './components/Contact';
import Projects from './components/Projects';
import Skills from './components/Skills';
import About from './components/About';


function App() {
  const [theme, setTheme] = useState('dark');

  const projects = [
    {
      id: 1,
      title: 'Dialogue',
      description: 'A basic dialogue system commision',
      videoId: 'DDbVghYqI2s',
    },
    {
      id: 2,
      title: 'Skill move commision',
      description: 'Nothing crazy, some basic animation events, screenshakes and other small effects. Anims or vfx not made by me',
      videoId: 'n9RTp76CtQk'
    },
    {
      id: 3,
      title: "Rock Lee Skillset Showcase",
      description: "Fully working Rock Lee skillset commision",
      videoId: "SQ430f0mJoI"
    },
    {
      id: 4,
      title: "Sword Combat Commision",
      description: "Frontend and Backend ready sword combat with aerial combat, heavy attacks and parrying",
      videoId: "YnkoW2cNM4Q"
    },
    {
      id: 5,
      title: "Advanced movement system",
      description: "A fully functioning movement system including double jumping, dashing, running, wall running and sliding",
      videoId: "SmIz4afBGFs"
    }
  ];

  useEffect(() => {
    document.body.className = '';
    document.body.classList.add(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const sectionVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.8 }, // Slightly more pronounced entry
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.8, // Slightly longer duration
        ease: "easeOut",
        when: "beforeChildren", // Animate parent first
        staggerChildren: 0.2, // Stagger children animations
      },
    },
  };

  return (
    <div className="App">
      <header className="App-header">
        <nav>
          <ul>
            <li><a href="#about">About</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
        <button onClick={toggleTheme}>
          {theme === 'dark' ? (
            <motion.span
              key="moon-icon"
              initial={{ rotate: 0, scale: 0.8 }}
              animate={{ rotate: 360, scale: 1 }}
              exit={{ rotate: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
            >
              <FaSun />
            </motion.span>
          ) : (
            <motion.span
              key="sun-icon"
              initial={{ rotate: 0, scale: 0.8 }}
              animate={{ rotate: 360, scale: 1 }}
              exit={{ rotate: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
            >
              <FaMoon />
            </motion.span>
          )}
        </button>
      </header>
      <main>
        <motion.section
          id="hero"
          initial="hidden"
          animate="visible"
          variants={sectionVariants}
        >
          <h1>Uzoph</h1>
          <p className="timezone-info"><FaMapMarkerAlt /> EU UTC+3</p>
          <TypeAnimation
            sequence={[
              'Roblox Luau Scripter',
              1000,
              'Full-Stack Developer',
              1000,
              'Python Developer',
              1000,
              'JavaScript Developer',
              1000,
            ]}
            wrapper="p"
            speed={50}
            repeat={Infinity}
          />
        </motion.section>
        <About />
        <Skills />
        <Projects projects={projects} />

        <Contact />
      </main>
      <ScrollToTopButton />
      <footer>
        <p>&copy; 2026 Uzoph. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;